import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import ErrorBoundary from 'src/error/components/ErrorBoundary';
import { firstResultsFetchedSelector } from '../../searchStatus/selectors';
import SubscribeLoader from './components/SubscribeLoader';

const Subscribe = lazy(
  () => import(/* webpackChunkName: "Subscribe" */ './Subscribe'),
);

const LazySubscribe = (props: PropsFromRedux): JSX.Element => {
  const { isFirstResultsFetched, isMobile } = props;

  if (!isFirstResultsFetched) {
    return <SubscribeLoader isMobile={isMobile} />;
  }
  return (
    <ErrorBoundary showDialog={false}>
      <Suspense fallback={<SubscribeLoader isMobile={isMobile} />}>
        <Subscribe />
      </Suspense>
    </ErrorBoundary>
  );
};

const mapStateToProps = (state) => ({
  isFirstResultsFetched: firstResultsFetchedSelector(state),
  isMobile: getIsMobile(state),
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(LazySubscribe);
